<script setup lang="ts">
import { useNav } from '~/composables/useNav'

const { items } = useNav()
const mobileOpen = ref(false)

const handleAction = async () => {
  await signOut()
  await navigateTo('/login', { external: true })
}

useCompanyTheme()
</script>

<template>
  <div class="min-h-screen">
    <UHeader
      v-model:open="mobileOpen"
      title="Fibertex Kantine"
      :ui="{ title: 'text-primary' }"
    >
      <!-- Desktop nav -->
      <UNavigationMenu
        :items="items"
        class="hidden lg:flex"
        orientation="horizontal"
        highlight
        highlight-color="primary"
        :ui="{
          childLink: [
            'px-3 py-2 rounded transition-colors',
            'before:bg-transparent hover:before:bg-transparent',
            'hover:text-primary',
            'data-[active]:text-primary data-[active]:font-semibold',
            'data-[active]:before:bg-transparent'
          ].join(' ')
        }"
      />

      <template #right>
        <div class="hidden lg:flex items-center gap-1.5">
          <button
            class="group w-full text-left p-1 flex items-center gap-1.5 text-sm font-medium text-muted hover:text-primary transition-colors"
            @click="handleAction"
          >
            <UIcon
              name="i-lucide-log-out"
              class="shrink-0 size-5 text-dimmed group-hover:text-primary transition-colors"
            />
            Log ud
          </button>

          <HelpPopover class="p-1" />

          <UColorModeSwitch class="p-1" />
        </div>
      </template>

      <!-- Mobile menu content -->
      <template #body>
        <div class="flex flex-col gap-2">
          <UNavigationMenu
            :items="items"
            orientation="vertical"
            class="w-full"
          />

          <USeparator />
          <button
            class="group w-full flex items-center gap-2 px-3 text-sm font-medium text-muted hover:text-primary transition-colors"
            @click="handleAction"
          >
            <UIcon
              name="i-lucide-log-out"
              class="shrink-0 size-5 text-dimmed group-hover:text-primary transition-colors"
            />
            <span class="truncate">Log ud</span>
          </button>

          <HelpPopover label="Hjælp" />

          <div
            class="group w-full flex items-center justify-between
         px-3 text-sm font-medium text-muted"
          >
            <div class="flex items-center gap-2">
              <UIcon
                name="i-lucide-sun-moon"
                class="shrink-0 size-5 text-dimmed"
              />
              <span>Dark mode</span>
            </div>

            <UColorModeSwitch />
          </div>
        </div>
      </template>
    </UHeader>

    <UMain>
      <UContainer>
        <slot />
      </UContainer>
    </UMain>
  </div>
</template>
